import './App.css';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ChooserPage from './pages/ChooserPage';
import HomeOwnersPage from './pages/HomeOwnersPage';
import StudentsPage from './pages/StudentsPage';
import QuoteWizard from './pages/QuoteWizard';
import ErrorPage from './pages/ErrorPage';

// BrowserRouter keeps the old scroll position between pages; start each new page at the top.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function RedirectOnRefresh() {
  const location = useLocation();
  const validRoutes = ["/book", "/packages", "/register"];

  if (validRoutes.includes(location.pathname)) {
    return <Navigate to="/error" />;
  }

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<ChooserPage />} />
        <Route path="/home-owners" element={<HomeOwnersPage />} />
        <Route path="/students" element={<StudentsPage />} />
        <Route path="/book" element={<QuoteWizard key="one-time" mode="one-time" />} />
        <Route path="/packages" element={<QuoteWizard key="seasonal" mode="seasonal" />} />
        <Route path="/register" element={<StudentsPage legacyRegister />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="*" element={<RedirectOnRefresh />} />
      </Routes>
    </Router>
  );
}

export default App;
